import React from 'react';
import { useModal } from '../../../../../../hooks/Modal';
import api from "../../../../../../services/api"
import { simpleDateBR } from "../../../../../../utils/date";
import { FaFileExcel, FaQrcode } from 'react-icons/fa';
 
import useCrachaLoteAgendamento from '../../../../core/components/lineModules/CrachaLoteAgendamentoFunction';
import UpdateStudentMulti from '../../../../../DashboardUserPages/Pages/Agendamentos/modules/UploadMultiStudents';

export default function UpdateStudents({lineData}): JSX.Element {

const {addModal, removeModal} = useModal();
 
 

  const openUpdateMulti = (hash) => {


  addModal({ title: '', theme: 'whiteModalMini', content: <UpdateStudentMulti hash={hash} setCallback={() => removeModal('atualizar-alunos-list')} />, key: "atualizar-alunos-list" })

    
  }


return <button className='searchButton' title='Upload via lista' type='button' onClick={() => openUpdateMulti(lineData?.hash)}><FaFileExcel /></button>




}